import React, { Component } from 'react'
import './breadcrumbs.scss';
import Link from 'gatsby-link'
import PropTypes from "prop-types";

class Breadcrumbs extends Component {

  render() {
    const {currentPageTitle, pageList} =  this.props;

    return (
      <div className="breadcrumbs__container">
        <div className="breadcrumbs__wrapper">
          <ul className="breadcrumbs">
            <li className="breadcrumbs__page">
              <Link to="/" className="breadcrumbs__link">
                Review
              </Link>
              <span className="breadcrumbs__sign"> > </span>
            </li>
            {pageList ? this.getBreadcrumbsList(pageList) : null}
            <li className="breadcrumbs__current-page">
              {currentPageTitle}
            </li>
          </ul>
        </div>
      </div>
    )
  }

  getBreadcrumbsList(list) {
    return (
      list.map((item) => {
        return (
          <li className="breadcrumbs__item" key={item.name}>
            <Link to={item.path} className="breadcrumbs__link">
              {item.name}
            </Link>
            <span className="breadcrumbs__sign"> > </span>
          </li>
        )
      })
    )
  }
}

Breadcrumbs.propTypes = {
  currentPageTitle: PropTypes.string,
  pageList: PropTypes.array,
};

export default Breadcrumbs;



// WEBPACK FOOTER //
// ./src/components/breadcrumbs/breadcrumbs.js